import React, { useContext, useState, useEffect } from "react";
import "../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import Offcanvas from "react-bootstrap/Offcanvas";
import Card from "react-bootstrap/Card";
import Select from "react-select";
import ModalSave from "../common/ModelSave";
import { CancelButton, SaveButton } from "../common/Button";
import {
  Row,
  Col,
  Form,
  Modal,
  Container,
  InputGroup,
  Button,
} from "react-bootstrap";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import classNames from "classnames";
import { Context } from "../../utils/context";
import JoditEditor from "jodit-react";
import Table from "react-bootstrap/Table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ImageValidation } from "../../utils/common";
import { ValidationImage } from "../../utils/api";

const AddOffCanvanceCharges = (props) => {
  const { postData, getData, Select2Data, getDimension } = useContext(Context);
  const {
    control,
    register,
    handleSubmit,
    getValues,
    formState: { errors },
    watch,
    setValue,
    reset,
  } = useForm();
  const id = props.selectedId;
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const onSubmit = async (data) => {
    try {
      console.log(data);
      const finalData = new FormData();
      finalData.append("booking_id", id);
      finalData.append("driver_name", data?.driver_name);
      finalData.append("driver_number", data?.driver_number);
      finalData.append("cab_number", data?.cab_number);
      const response = await postData(`/booking/booking-charges/${id}`, data);

      if (response?.success) {
        setShowModal({ code: response.code, message: response.message });
      } else {
        setShowModal({ code: response.code, message: response.message });
      }
      setTimeout(() => {
        setShowModal(0);
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };
  const cabType = props.cabType;

  return (
    <>
      <div className="prodcuttttt">
        <Offcanvas
          show={props.show}
          style={{ width: "80%" }}
          placement={"end"}
          onHide={props.handleClose}
          className="prodcuttttt-offcanvas"
        >
          <Offcanvas.Header closeButton>
            {/* <Offcanvas.Title>Add Employee</Offcanvas.Title> */}
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Card className="shadow-lg p-3 mb-5  rounded card card">
              <Card.Body>
                <Card.Title>Add Booking Charges</Card.Title>
                <hr />
                <Container>
                  <Form
                    // onSubmit={() => handleSubmit(onSubmit)}
                    role="form"
                    // className="stateclass"
                  >
                    <Row>
                      <Col md={6}>
                        <div className="main-form-section mt-3">
                          <Row className="justify-content-center">
                            <Form.Label>Airport Charges</Form.Label>
                            <Form.Group>
                              <InputGroup>
                                <Form.Control
                                  type="text"
                                  name="airport_charges"
                                  placeholder="Airport Charges .."
                                  // className={classNames("", {
                                  //   "is-invalid": errors?.airport_charges,
                                  // })}
                                  // {...register("airport_charges", {
                                  //   // required: "Airport Charges is required",
                                  // })}
                                  {...register("airport_charges")}
                                  onKeyPress={(e) => {
                                    if (!/[0-9.]/.test(e.key))
                                      e.preventDefault();
                                  }}
                                />
                              </InputGroup>
                              {/* {errors.airport_charges && (
                                <span className="text-danger">
                                  {errors.airport_charges.message}
                                </span>
                              )} */}
                            </Form.Group>
                          </Row>
                        </div>
                      </Col>
                      <Col md={6}>
                        <div className="main-form-section mt-3">
                          <Row className="justify-content-center">
                            <Form.Label>Extra Kilometer Charges</Form.Label>
                            <Form.Group>
                              <InputGroup>
                                <Form.Control
                                  type="text"
                                  name="extra_pickup_drop"
                                  placeholder="Extra Kilometer Charges"
                                  // className={classNames("", {
                                  //   "is-invalid":
                                  //     errors?.,
                                  // })}
                                  // {...register("extra_kilometer_charges", {
                                  //   // required: "Extra Kilometer Charges is required",
                                  // })}
                                  {...register("extra_kilometer_charges")}
                                  onKeyPress={(e) => {
                                    if (!/[0-9.]/.test(e.key))
                                      e.preventDefault();
                                  }}
                                />
                              </InputGroup>
                              {/* {errors.extra_kilometer_charges && (
                                <span className="text-danger">
                                  {errors.extra_kilometer_charges.message}
                                </span>
                              )} */}
                            </Form.Group>
                          </Row>
                        </div>
                      </Col>

                      <Col md={6}>
                        <div className="main-form-section mt-3">
                          <Row className="justify-content-center">
                            <Form.Label>Extra Pickup</Form.Label>
                            <Form.Group>
                              <InputGroup>
                                <Form.Control
                                  type="text"
                                  name="extra_pickup_drop"
                                  placeholder="Extra Pickup .."
                                  // className={classNames("", {
                                  //   "is-invalid": errors?.extra_pickup_drop,
                                  // })}
                                  // {...register("extra_pickup_drop", {
                                  //   // required: "Extra Pickup is required",
                                  // })}
                                  {...register("extra_pickup_drop")}
                                  onKeyPress={(e) => {
                                    if (!/[0-9.]/.test(e.key))
                                      e.preventDefault();
                                  }}
                                />
                              </InputGroup>
                              {/* {errors.extra_pickup_drop && (
                                <span className="text-danger">
                                  {errors.extra_pickup_drop.message}
                                </span>
                              )} */}
                            </Form.Group>
                          </Row>
                        </div>
                      </Col>
                      <Col md={6}>
                        <div className="main-form-section mt-3">
                          <Row className="justify-content-center">
                            <Form.Label>Extra Drop</Form.Label>
                            <Form.Group>
                              <InputGroup>
                                <Form.Control
                                  type="text"
                                  name="extra_drop"
                                  placeholder="Extra Drop .."
                                  // className={classNames("", {
                                  //   "is-invalid": errors?.extra_drop,
                                  // })}
                                  // {...register("extra_drop", {
                                  //   // required: "Extra Drop is required",
                                  // })}
                                  {...register("extra_drop")}
                                  onKeyPress={(e) => {
                                    if (!/[0-9.]/.test(e.key))
                                      e.preventDefault();
                                  }}
                                />
                              </InputGroup>
                              {/* {errors.extra_drop && (
                                <span className="text-danger">
                                  {errors.extra_drop.message}
                                </span>
                              )} */}
                            </Form.Group>
                          </Row>
                        </div>
                      </Col>
                      <Col md={6}>
                        <div className="main-form-section mt-3">
                          <Row className="justify-content-center">
                            <Form.Label>Driver Allowance</Form.Label>
                            <Form.Group>
                              <InputGroup>
                                <Form.Control
                                  type="text"
                                  name="driver_allowance"
                                  placeholder="Driver Allowance .."
                                  // className={classNames("", {
                                  //   "is-invalid": errors?.driver_allowance,
                                  // })}
                                  // {...register("driver_allowance", {
                                  //   // required: "Driver Allowance is required",
                                  // })}
                                  {...register("driver_allowance")}
                                  onKeyPress={(e) => {
                                    if (!/[0-9.]/.test(e.key))
                                      e.preventDefault();
                                  }}
                                />
                              </InputGroup>
                              {/* {errors.driver_allowance && (
                                <span className="text-danger">
                                  {errors.driver_allowance.message}
                                </span>
                              )} */}
                            </Form.Group>
                          </Row>
                        </div>
                      </Col>

                      <Col md={6}>
                        <div className="main-form-section mt-3">
                          <Row className="justify-content-center">
                            <Form.Label>Night Allowance</Form.Label>
                            <Form.Group>
                              <InputGroup>
                                <Form.Control
                                  type="text"
                                  name="night_allowance"
                                  placeholder="Night Allowance .."
                                  // className={classNames("", {
                                  //   "is-invalid": errors?.night_allowance,
                                  // })}
                                  // {...register("night_allowance", {
                                  //   // required: "Night Allowance is required",
                                  // })}
                                  {...register("night_allowance")}
                                  onKeyPress={(e) => {
                                    if (!/[0-9.]/.test(e.key))
                                      e.preventDefault();
                                  }}
                                />
                              </InputGroup>
                              {/* {errors.night_allowance && (
                                <span className="text-danger">
                                  {errors.night_allowance.message}
                                </span>
                              )} */}
                            </Form.Group>
                          </Row>
                        </div>
                      </Col>
                      <Col md={6}>
                        <div className="main-form-section mt-3">
                          <Row className="justify-content-center">
                            <Form.Label>Border Tax</Form.Label>
                            <Form.Group>
                              <InputGroup>
                                <Form.Control
                                  type="text"
                                  name="border_tax"
                                  placeholder="Border Tax .."
                                  // className={classNames("", {
                                  //   "is-invalid": errors?.border_tax,
                                  // })}
                                  // {...register("border_tax", {
                                  //   // required: "Border Tax is required",
                                  // })}
                                  {...register("border_tax")}
                                  onKeyPress={(e) => {
                                    if (!/[0-9.]/.test(e.key))
                                      e.preventDefault();
                                  }}
                                />
                              </InputGroup>
                              {/* {errors.border_tax && (
                                <span className="text-danger">
                                  {errors.border_tax.message}
                                </span>
                              )} */}
                            </Form.Group>
                          </Row>
                        </div>
                      </Col>
                      <Col md={6}>
                        <div className="main-form-section mt-3">
                          <Row className="justify-content-center">
                            <Form.Label>Parking</Form.Label>
                            <Form.Group>
                              <InputGroup>
                                <Form.Control
                                  type="text"
                                  name="parking"
                                  placeholder="Parking .."
                                  // className={classNames("", {
                                  //   "is-invalid": errors?.parking,
                                  // })}
                                  // {...register("parking", {
                                  //   // required: "Parking is required",
                                  // })}
                                  {...register("parking")}
                                  onKeyPress={(e) => {
                                    if (!/[0-9.]/.test(e.key))
                                      e.preventDefault();
                                  }}
                                />
                              </InputGroup>
                              {/* {errors.parking && (
                                <span className="text-danger">
                                  {errors.parking.message}
                                </span>
                              )} */}
                            </Form.Group>
                          </Row>
                        </div>
                      </Col>
                      <Col md={6}>
                        <div className="main-form-section mt-3">
                          <Row className="justify-content-center">
                            <Form.Label>Toll Charges</Form.Label>
                            <Form.Group>
                              <InputGroup>
                                <Form.Control
                                  type="text"
                                  name="Toll Charges"
                                  placeholder="Toll .."
                                  // className={classNames("", {
                                  //   "is-invalid": errors?.toll,
                                  // })}
                                  // {...register("toll", {
                                  //   // required: "toll is required",
                                  // })}
                                  {...register("toll")}
                                  onKeyPress={(e) => {
                                    if (!/[0-9.]/.test(e.key))
                                      e.preventDefault();
                                  }}
                                />
                              </InputGroup>
                              {/* {errors.toll && (
                                <span className="text-danger">
                                  {errors.toll.message}
                                </span>
                              )} */}
                            </Form.Group>
                          </Row>
                        </div>
                      </Col>

                      <Row className="mt-5 pb-3">
                        <div className="d-flex justify-content-center">
                          <Link>
                            <CancelButton
                              name={"cancel"}
                              handleClose={props.handleClose}
                            />
                          </Link>

                          <SaveButton
                            name={"save"}
                            handleSubmit={handleSubmit(onSubmit)}
                          />
                        </div>
                      </Row>
                    </Row>
                  </Form>
                </Container>
              </Card.Body>
            </Card>
          </Offcanvas.Body>
        </Offcanvas>

        <ModalSave
          message={showModal.message}
          showErrorModal={showModal.code ? true : false}
        />
      </div>
    </>
  );
};

export default AddOffCanvanceCharges;
